export const CATEGORY_SALARIED = 'SL';
export const CATEGORY_INDIRECT = 'IDL';
export const CATEGORY_DIRECT = 'DL';